/* Display only. Shopify Functions determine all discount eligibility and prices. */
(() => {
  if (window.cmBrisbaneLaunchNotice) {
    window.cmBrisbaneLaunchNotice.refresh();
    return;
  }

  let timer;
  const refresh = () => {
    window.clearTimeout(timer);
    const now = Date.now();
    let nextBoundary = Infinity;

    document.querySelectorAll('[data-cm-bogo-notice]').forEach((notice) => {
      const start = Date.parse(notice.dataset.start);
      const end = Date.parse(notice.dataset.end);
      if (!Number.isFinite(start) || !Number.isFinite(end) || now >= end) {
        notice.hidden = true;
        return;
      }
      notice.hidden = false;
      nextBoundary = Math.min(nextBoundary, end);
    });

    if (Number.isFinite(nextBoundary)) {
      timer = window.setTimeout(refresh, Math.min(Math.max(nextBoundary - now + 50, 50), 2147483647));
    }
  };

  window.cmBrisbaneLaunchNotice = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
